export function getApiBase(): string {
  if (process.env.NEXT_PUBLIC_TAURI === 'true') {
    return 'https://equitylabs.app';
  }
  return '';
}
